export default {
  "title": {
    "operations": "All operations indicators",
    "carrier": "All carriers indicators",
    "plant": "All plant’s indicators",
    "driversAtRisk": "At risk drivers (daily improvement)",
    "distribution": "distribution",
    "microSleep": "Drowsiness events / 100 hours daily driving",
    "microSleepBar": "Daily drowsiness events",
    "behavior": "Daily behavioral grade",
    "ubicationpvt": "All PVT location’s indicators",
    "contract": "All contract’s indicators",
    "evolutionMicrosleeps": "Evolution drowsiness events",
    "general": {
      "operations": "all operations",
      "carrier": "all carriers",
      "plant": "all plants",
      "ubicationpvt": "all PVT locations",
      "contract": "all contracts"
    }
  },
  "tableTitle": {
    "operations": "Operation",
    "operation": "Operation",
    "carrier": "Carrier",
    "carriers": "Carriers",
    "drivers": "Drivers",
    "atRisk": "At risk",
    "distribution": "At risk distribution",
    "driversAtRisk": "At risk drivers (daily improvement)",
    "inspectionCarriedOut": "Inspections %",
    "formAvgRange": "Average grade",
    "evolutionScore": "Grade improvement",
    "inspections": "Inspections",
    "fails": "Failure",
    "severityFailsColor": "Failures seriousness",
    "microSleep": "Drowsiness events / 100 hours daily driving",
    "microSleepBar": "Daily drowsiness events",
    "behavior": "Daily behavioral grade",
    "ubicationpvt": "PVT location",
    "ubicationpvts": "PVT location",
    "contract": "Contract",
    "contracts": "Contract",
    "numberRanking": "Ranking No.",
    "driverName": "Driver name",
    "biocompatibilityIndex": "Biocompatibility Index"
  },
  "filter": {
    "all": "All",
    "formTypes": "Type",
    "existentUsers": "Inspector",
    "existentPersons": "Driver",
    "existentVehicles": "Equipment",
    "existentForms": "Form",
    "existentFails": "Failures",
    "selectType": "Type",
    "selectInspector": "Inspector",
    "selectDriver": "Driver",
    "selectVehicle": "Equipment",
    "selectForm": "Form",
    "selectFails": "Defects",
    "selectTask": "Tasks",
    "selectState": "Condition"
  },
  "text": {
    "withFails": "No failures"
  },
  "graphTooltip": {
    "outOfRisk": "Out of risk",
    "midleRisk": "Medium risk",
    "atRisk": "At risk",
    "LOWRISK": "Out of risk",
    "OUTOFRISK": "Out of risk",
    "MIDDLERISK": "Medium risk",
    "HIGHRISK": "At risk",
    "OPEN": "Open",
    "OVERDUE": "Expired",
    "CLOSEDOVERDUE": "Closed expired",
    "CLOSED": "Closed",
    "ACCEPTED": "Approved",
    "FAIR": "Approved with observations",
    "REJECTED": "Denied",
    "NODATA": "No information",
    "WITHOUTINFORMATION": "No information",
    "SYNC": "Synchronized",
    "SYNCWITHDELAY": "Synchronized in delay",
    "NOTSYNC": "No synchronization",
    "DONE": "On time",
    "DONEWITHDELAY": "Delayed",
    "PENDING": "Not done",
    "GOOD": "Low",
    "MEDIUM": "Medium",
    "BAD": "High"
  },
  "fatigue": {
    "labelText": "It represents the driver’s percentage with Biocompatibility indicators (BCI) over 60 until date. The BCI allows you to identify how risky the shift structure of the driver is. It is calculated considering these variables: shift Schedule, resting duration, among others. For this, schedules from beginning to end of a shift, are processed withing the last 14 days of work and this rate is given and can vary between 0 to a 100.",
    "underRisk": "Low risk",
    "midleRisk": "Medium risk",
    "to": "to",
    "highRisk": "High risk",
    "driversAtRisk": "Drivers at risk",
    "distributionIndex": "Biocompatibility rates distribution of the drivers of the selected dates in the filter \"to\". Distributed as low risk, medium risk and high risk.",
    "biocompatibilityEvolution": "Biocompatibility evolution",
    "driversAtRiskText": "Represents the percentage of drivers at high risk due to the structure of their work shift.",
    "ratesHistogramText": "It allows to visualize with greater level of detail how many drivers are in each level of risk.",
    "mainIndicatorsText": "They allow a quick overview of the functioning of the operation and its potential risk factors."
  },
  "nfa": {
    "distributionRisk": "Risk distribution",
    "underRisk": "Total risk is low",
    "driverFatigue": "It represents the percentage of drivers / day with accumulated fatigue level in 4 selected periods of time",
    "fatigueLevelAccumulation": "Levels of accumulated fatigue: indicator which calculated the probability that at least one drowsiness event occurs in a shift within the next 24 hours. There are 4 classification levels according to risk",
    "percentageEmsOne": "0% to 2% from suffering an drowsiness event in your next shift",
    "percentageEmsTwo": "2% to 10% from suffering an drowsiness event in your next shift",
    "percentageEmsThree": "10% to 20% from suffering an drowsiness event in your next shift",
    "_percentageEmsThree": "20% to 100% from suffering an drowsiness event in your next shift",
    "howItGoes": "How you are doing regarding the objective",
    "meta": "Objective",
    "before": "Last period",
    "to": "to",
    "driverNumber": "Number of drivers",
    "atRisk": "At risk",
    "riskPeriod": "Risk % of the period",
    "driversAtRisk": "% of drivers at risk",
    "riskDistribution": "Distribution in risk",
    "deviationDitribution": "Deviation distribution",
    "noData": "There is no more data",
    "title": "All operations accumulated fatigue levels improvement",
    "titleSecond": "All operations indicators",
    "indicadors": "All drivers indicators",
    "now": "Current period",
    "overdue": "Expired",
    "closedoverdue": "Expired closed",
    "open": "Open",
    "closed": "Close"
  },
  "ffdSleep": {
    "MONTH": "Month",
    "DAY": "Day",
    "WEEK": "Week",
    "downloadExcel": "Download data in an Excel file",
    "downloadSummaryExcel": "Download summarized data",
    "downloadNoProcessExcel": "Download unprocessed data",
    "noDataAvailable": "There is no information available",
    "apiError": "Error when charging data",
    "noDevs": "There are no deviations",
    "lastPeriod": "Last period",
    "thisPeriod": "Current period",
    "to": "to",
    "betterPeriod": "better compared to the last period",
    "worstPeriod": "worst compared to the last period",
    "equalPeriod": "There are no changed compared to the las period",
    "graphTooltip": {
      "ACCEPTED": "Approved",
      "FAIR": "Approved with observations",
      "REJECTED": "Rejected",
      "NODATA": "No synchronization incident",
      "WITHOUTINFORMATION": "No synchronization incident",
      "SYNC": "Synchronized",
      "SYNCWITHDELAY": "In delayed synchronization",
      "NOTSYNC": "Not synchronized"
    },
    "FFDResult": {
      "indicatorPeriod": "FFD rejection rate from the period",
      "resultsDistribution": "FFD results distribution of the period",
      "title": "Rejection rate fitness for duty (FFD) improvement",
      "evTooltip": "Rejected",
      "indicatorHelp1": "It represents the total percentage of occasions in which a number of people was evaluated as not capable for the job, this is known as rejected for FITNESS FOR DUTY.",
      "indicatorHelp2": "This indicator is calculated based on the total number of expected evaluations in the selected dates of the period.",
      "indicatorHelp3": "Currently the total rejection’s rate",
      "evHelp1": "It represents the rejection for FITNESS FOR DUTY rate improvement during the selected dates of the period.",
      "evHelp2": "The number represents the percentage of rejections for dd-mm-yyyy.",
      "distHelp1": "It represents the amount of people per group of results in the FITNESS FOR DUTY from the selected dates of the period.",
      "cat1Label": "Approved",
      "cat1": "people capable for the job.",
      "cat2Label": "Approved with observations",
      "cat2": "people capable to work under monitoring and/or a mitigation plan of preventive fatigue measures.",
      "cat3Label": "Rejected",
      "cat3": "people who are not in capable conditions to work",
      "cat4Label": "No synchronization incident",
      "cat4": "people who did not synchronize their sleep bracelets appropriately.",
      "desvHelp1": "It represents the number of deviations made in the selected period and their current state:",
      "desvCat1Label": "Closed on time",
      "desvCat2Label": "Open",
      "desvCat3Label": "Expired",
      "desvCat4Label": "Expired closed",
      "labelRate": "Rejection rate",
      "between": "Between",
      "categoryHelp": "Summary association category.",
      "driverNumber": "People",
      "driverNumberHelp": "Number of people visualized in the selected dates period.",
      "atRisk": "FFD rejections",
      "atRiskHelp": "It represents the number of rejections of FITNESS FOR DUTY for dd-mm-yyyy.",
      "riskPeriod": "Percentage of rejections of the period",
      "driversAtRisk": "FFD rate of rejection improvement",
      "riskDistribution": "FFD result’s distribution",
      "deviationDitribution": "Deviations distributions for FFD rejection",
      "noData": "There is no more data",
      "now": "This period",
      "overdue": "Expired",
      "closedoverdue": "Expired closed",
      "open": "Open",
      "closed": "Close",
      "generalHelp": "* Rejection: It refers to the occasion(s) in which one or more people were evaluated as not capable to work through the FITNESS FOR DUTY calculation."
    },
    "FFDSync": {
      "indicatorPeriod": "Rate of incidents from sleep bracelets synchronizations during the period",
      "resultsDistribution": "Distribution condition of the synchronization of sleep bracelets during the period",
      "title": "Rate evolution of the incidents from sleep bracelets synchronization",
      "evTooltip": "Incidents",
      "indicatorHelp1": "It represents the total percentage of incidents from the sleep bracelets synchronization occurred during shift from the selected period.",
      "indicatorHelp2": "This indicator is calculated based on the total number of expected evaluations for FITNESS FOR DUTY during the selected dates of the period.",
      "indicatorHelp3": "Currently the total rate of incidents is",
      "evHelp1": "It represents the improvement on the incidents rate within the synchronization of sleep bracelets during the selected dates of the period.",
      "evHelp2": "This number represents the percentage of incidents on dd-mm-yyyy.",
      "distHelp1": "It represents the total number of cases for each condition of synchronization of the sleep bracelets during the selected dates of the period.",
      "cat1Label": "Synchronized",
      "cat1": "people who have synchronized properly.",
      "cat2Label": "Synchronized with delay",
      "cat2": "people who have synchronized out of the established time and have for that reason provoked a FITNESS FOR DUTY report with delay.",
      "cat3Label": "Not synchronized",
      "cat3": "people who presented a synchronization incident and have not generated information about FITNESS FOR DUTY for any particular date.",
      "desvHelp1": "It represents the number of generated deviations in the selected period and its current condition:",
      "desvCat1Label": "Closed on time",
      "desvCat2Label": "Open",
      "desvCat3Label": "Expired",
      "desvCat4Label": "Expired closed",
      "labelRate": "Indicident’s rate",
      "between": "Between",
      "categoryHelp": "Summary association category.",
      "driverNumber": "People",
      "driverNumberHelp": "Number of people visualized in the selected dates of the period.",
      "atRisk": "Incidents",
      "atRiskHelp": "It represents the number of incidents withing the synchronixation of sleep bracelets for dd-mm-yyyy.",
      "riskPeriod": "Incidents percentage of the period",
      "driversAtRisk": "Incident’s rate improvement",
      "riskDistribution": "Distribution of the conditions of synchronization",
      "deviationDitribution": "Deviations for incidents distribution",
      "noData": "There is no more data",
      "now": "This period",
      "overdue": "Expired",
      "closedoverdue": "Expired closed",
      "open": "Open",
      "closed": "Closed",
      "generalHelp": "* Incident: It refers to the occasion(s) in which one or more people have not completed the synchronization process for the sleep bracelets for its FITNESS FOR DUTY calculation."
    },
    "lastDataView": {
      "name": "Name",
      "categories": "Category",
      "categoriesHelp": "Category to which the person belongs, example: plant, operation, transportation.",
      "workingShiftGroup": "Shift group",
      "workingShiftGroupHelp": "It corresponds to the shift rotation group to which each person is assigned to at the date of the consult.",
      "ffdScore": "FFD score",
      "ffdScoreHelp": "It corresponds to the result of the FITNESS FOR DUTY. This score is calculated based on sleep and wakefulness within the last 48 hours.",
      "calcDate": "Calculation date",
      "calcDateHelp": "It corresponds to the date and time in which the FITNESS FOR DUTY evaluation took place.",
      "fitnessForDuty": "Fitness for Duty Sleep Bracelets",
      "ACCEPTED": "Approved",
      "FAIR": "Approved with observations",
      "REJECTED": "Rejected",
      "NODATA": "No synchronization incident",
      "ACCEPTEDHelp": "between 100 and 80 points",
      "FAIRHelp": "between 81 and 60 points",
      "REJECTEDHelp": "between 59 and 0 points",
      "NODATAHelp": "synchronization incident",
      "syncDate": "Last synchronization information",
      "last48hoursSleepInHour": "Last 48 hours of sleep",
      "last24hoursSleepInHour": "Last 24 hours of sleep",
      "hoursFromWakeUp": "Hours of wakefulness since the last wakening"
    }
  },
  "ffdPvt": {
    "MONTH": "Month",
    "DAY": "Day",
    "WEEK": "Week",
    "downloadExcel": "Download data in an Excel file",
    "downloadSummaryExcel": "Download summarized data",
    "downloadNoProcessExcel": "Download unprocessed data",
    "downloadFileNameSummary": "data_cognus_pvt_summary",
    "downloadFileNameNoProcess": "data_cognus_pvt_no_process",
    "downloadErrorDateRangeTitle": "Download date range not allowed",
    "downloadErrorDateRangeDescription": "You have exceeded the allowed download date range (3 days or less). To request a report covering a period greater than 31 days, please contact the Gauss Control help desk.",
    "noDataAvailable": "There is no information available",
    "apiError": "Data charging error",
    "noDevs": "There are no deviations",
    "noData": "There is no data",
    "lastPeriod": "Last period",
    "thisPeriod": "Current period",
    "to": "to",
    "betterPeriod": "better compared to the last period",
    "worstPeriod": "worst compared to the last period",
    "equalPeriod": "There are no changes compared to the last period",
    "graphTooltip": {
      "ACCEPTED": "Approved",
      "FAIR": "Approved with observations",
      "REJECTED": "Rejected",
      "NODATA": "Incident of non-realization",
      "WITHOUTINFORMATION": "Incident of non-realization",
      "DONE": "On time",
      "DONEWITHDELAY": "Delayed",
      "PENDING": "Not completed"
    },
    "FFDResult": {
      "indicatorPeriod": "Cognus rejection rate from the period",
      "resultsDistribution": "Cognus results distribution from the period",
      "title": "Cognus rejection rate improvement",
      "evTooltip": "Rejected",
      "indicatorHelp1": "It represents the total percentage of occasions in which a number of people was evaluated as not capable for the job; this is known as Cognus rejection.",
      "indicatorHelp2": "This indicator is calculated based on the total number of evaluations from the selected dates of the period.",
      "indicatorHelp3": "Currently the total rate of rejection is",
      "evHelp1": "It represents the evolution of the Cognus rejection’s rate of the selected dates of the period.",
      "evHelp2": "This number represents the total rejection’s percentage for dd-mm-yyyy.",
      "distHelp1": "It represents the number of people per group of results of the Cognus for the selected dates of the period.",
      "cat1Label": "Approved",
      "cat1": "people capable for the job.",
      "cat2Label": "Approved with observations",
      "cat2": "people capable to work under supervision and or a mitigation measures plan to prevent fatigue.",
      "cat3Label": "Rejected",
      "cat3": "people who are not in capable conditions to work.",
      "cat4Label": "Incident of non-realization",
      "cat4": "people who did not present to complete their PVT test.",
      "desvHelp1": "It represents the number of generated deviations in the selected period and current condition:",
      "desvCat1Label": "Closed in time",
      "desvCat2Label": "Open",
      "desvCat3Label": "Expired",
      "desvCat4Label": "Expired closed",
      "labelRate": "Rejection rate",
      "between": "between",
      "categoryHelp": "Summary association category.",
      "driverNumber": "People",
      "driverNumberHelp": "Number of people visualized in the selected dates of the period.",
      "atRisk": "Cognus rejections",
      "atRiskHelp": "It represents the number of rejections for Cognus for dd-mm-yyyy.",
      "riskPeriod": "Percentage of rejections of the period",
      "driversAtRisk": "Cognus rate of rejection improvement",
      "riskDistribution": "Cognus results distribution",
      "deviationDitribution": "Cognus rejections for deviations distribution",
      "noData": "There is no more data",
      "now": "This period",
      "overdue": "Expired",
      "closedoverdue": "Expired closed",
      "open": "Open",
      "closed": "Closed",
      "generalHelp": "* Rejection: It refers to the occasion(s) in which one or more people were evaluated at NOT CAPABLE to work through the COGNUS calculation."
    },
    "FFDRealization": {
      "indicatorPeriod": "Period incident rate within the PVT test realization",
      "resultsDistribution": "Distribution state of the PVT test completition of the period",
      "title": "Rate of incidents improvement on the PVT evaluation completion",
      "evTooltip": "Incidents",
      "indicatorHelp1": "It represents the total percentage of realization incidents on the PVT test that occurred during the selected shifts of the period.",
      "indicatorHelp2": "This indicator is calculated based on the total Cognus expected evaluations during the selected dates of the period.",
      "indicatorHelp3": "Currently the total rate of incidents is",
      "evHelp1": "It represents the improvement on the incidents rate on the realization of the PVT test during the selected dates of the period.",
      "evHelp2": "This number represents the incidents percentage for dd-mm-yyyy.",
      "distHelp1": "It represents the total number of cases for each state of realization of the PVT test during the selected dates of the period.",
      "cat1Label": "On time",
      "cat1": "people who have completed their PVT test in an adequate time.",
      "cat2Label": "Delayed",
      "cat2": "people who have completed their PVT test out of the established time and have for that reason caused a Cognus delayed report.",
      "cat3Label": "Not completed",
      "cat3": "people who have not completed their PVT test and have not generated Cognus information for any particular date.",
      "desvHelp1": "It represents the number of generated deviations for the selected period and their current condition:",
      "desvCat1Label": "Closed on time",
      "desvCat2Label": "Open",
      "desvCat3Label": "Expired",
      "desvCat4Label": "Expired closed",
      "labelRate": "Incident’s rate",
      "between": "between",
      "categoryHelp": "Summary association category.",
      "driverNumber": "People",
      "driverNumberHelp": "Number of people visualized within the selected dates of the period.",
      "atRisk": "Incidents",
      "atRiskHelp": "It represents the number of incidents in a PVT test realization for dd-mm-yyyy.",
      "riskPeriod": "Incidents percentage of the period",
      "driversAtRisk": "Incident’s rate improvement",
      "riskDistribution": "States of PVT test realization distribution",
      "deviationDitribution": "Distribution of deviations by incidents",
      "noData": "There is no more data",
      "now": "This period",
      "overdue": "Expired",
      "closedoverdue": "Expired closed",
      "open": "Open",
      "closed": "Closed",
      "generalHelp": "* Incident: It refers to the occasion(s) in which one or more people have not completed the PVT evaluation process for the COGNUS calculation."
    },
    "lastDataView": {
      "name": "Name",
      "categories": "Categories",
      "categoriesHelp": "Category to which the person belongs to, example: plant, operation, transportation.",
      "workingShiftGroup": "Shift group",
      "workingShiftGroupHelp": "It corresponds to the rotation shift group to which each person is assigned within the date of the consult.",
      "ffdScore": "Cognus score",
      "ffdScoreHelp": "It corresponds to the Cognus result. This result is calculated based on the PVT test.",
      "calcDate": "Calculation date",
      "calcDateHelp": "It corresponds to the date and time in which the Cognus evaluation took place.",
      "fitnessForDuty": "Cognus PVT test",
      "ACCEPTED": "Approved",
      "FAIR": "Approved with observations",
      "REJECTED": "Rejected",
      "NODATA": "No realization incident",
      "ACCEPTEDHelp": "between 100 and 80 points",
      "FAIRHelp": "between 79 and 60 points",
      "REJECTEDHelp": "between 59 and 0 points",
      "NODATAHelp": "PVT test realization incident",
      "LastSuccessfulAttempts": "Correct attempts",
      "LastMeasurements": "Number of measurements",
      "LastFailedAttempts": "Failed attempts",
      "LastFalsePositives": "False positives",
      "FirstRealizationDate": "First attempt date",
      "FirstResult": "First attempt result",
      "LastRealizationDate": "Last attempt date",
      "Version": "Number of PVT tests",
      "WITHOUTINFORMATION": "No realization incident",
      "PENDING": "Not completed",
      "DONE": "On time",
      "DONEWITHDELAY": "Delayed",
      "rejectReasons": "Rejection motive(s)",
      "rejectReason": "Rejection motive",
      "BREATHALYSER": "Breathalyzer test",
      "PVTTEST": "PVT",
      "FORM": "Survey"
    }
  },
  "behaviour": {
    "MONTH": "Month",
    "DAY": "Day",
    "WEEK": "Week",
    "downloadExcel": "Download data in an Excel file",
    "downloadSummaryExcel": "Download summarized data",
    "downloadNoProcessExcel": "Download unprocessed data",
    "noDataAvailable": "There is no information available",
    "apiError": "Charging data error",
    "indicatorPeriod": "Period’s behavioral grade",
    "resultsDistribution": "Behavioral grade distribution in the period",
    "title": "Behavioral daily grade improvement",
    "evTooltip": "Behavioral grade",
    "indicatorHelp1": "It represents the behavioral grades average of the drivers during the selected dates of the period.",
    "indicatorHelp1Table": "It represents the behavioral grades average for the {category} during the selected dates of the period.",
    "indicatorHelp2": "This indicator was calculated based on the behavioral grades according to the travelled kilometers, and for each driver.",
    "indicatorHelp1Driver": "It represents the behavioral grade average of the driver during the selected dates of the period.",
    "indicatorHelp2Driver": "This indicator was calculated based on the behavioral grades according to the travelled kilometers in each trip.",
    "indicatorHelp1Travel": "It corresponds to the behavioral grade per completed trip.",
    "indicatorHelp2Travel": "This indicator is calculated considering the associated events in each trip (right side panel).",
    "indicatorHelp1TravelModal": "It corresponds to the behavioral grade of the trip.",
    "indicatorHelp2TravelModal": "It is calculated based on the displayed indicators on the right side; these indicators are generated according to the number of events registered per trip, the duration of the trip and the travelled kilometers.",
    "indicatorHelp3": "Currently your behavioral grade is",
    "evHelp1": "It represents the improvement on the behavioral daily grade average of the selected dates of the period.",
    "evHelp2": "This number represents the behavioral grade for dd-mm-yyyy.",
    "distHelp1": "This distribution represents the number of drivers categorized by risk.",
    "distHelp2": "This indicator was calculated based on the behavioral grades according to the travelled kilometers per trip.",
    "between": "Between",
    "categoryHelp": "Summary association category",
    "driverNumber": "Drivers",
    "driverNumberHelp": "Number of visualized drivers in the selected dates of the period",
    "riskPeriod": "Behavioral grade average of the period",
    "driversAtRisk": "Behavioral grade improvement average",
    "riskDistribution": "Behavioral grade’s distribution of the period",
    "deviationDitribution": "Cognus rejection of deviations distributions",
    "noData": "There is no more data",
    "now": "This period",
    "overdue": "Expired",
    "closedoverdue": "Expired closed",
    "open": "Open",
    "closed": "Closed",
    "generalHelp": "The behavioral grade of the period is calculated based on all behavioral daily grades from the consult time gap.",
    "to": "to"
  }
};


// WEBPACK FOOTER //
// ./source/client/components/locales/language_configuration/english/summary/index.js